<div *transloco="let t" class="py-4">
	<mat-tab-group [mat-stretch-tabs]="false" preserveContent="true" class="mb-4">
		<mat-tab label="{{ t('settings.devSettings.supportTools.title') }}">
			<ara-support-tools></ara-support-tools>
		</mat-tab>

		<mat-tab label="{{ t('settings.devSettings.frontendTools.title') }}">
			<ara-frontend-tools></ara-frontend-tools>
		</mat-tab>
	</mat-tab-group>
</div>
